import * as React from 'react';
import { checkImg } from '@features/utils/functions';
import IAsyncImage, { TAsyncImage } from './IAsyncImage';

export default class AsyncImage extends React.PureComponent<IAsyncImage, TAsyncImage> {

  state: TAsyncImage = {
    imgUrl: this.props.image || this.props.fallback,
    shouldUpdateState: false,
  };

  setStateAsync(state:TAsyncImage) {
    return new Promise((resolve) => {
      if (!this.state.shouldUpdateState) {
        this.setState(state, resolve as () => void);
      }
    });
  }

  async componentDidMount() {
    const { image, fallback } = this.props;
    try {
      const img = await checkImg(image, fallback);
      await this.setStateAsync({ imgUrl:img });
    } catch {
      await this.setStateAsync({ imgUrl:fallback });
    }
  }

  async componentDidUpdate(prevProps: IAsyncImage, prevState: TAsyncImage) {
    if (this.props.image !== prevProps.image) {
      const { image, fallback } = this.props;

      try {
        const img = await checkImg(image, fallback);
        await this.setStateAsync({ imgUrl:img, shouldUpdateState: true });
      } catch {
        await this.setStateAsync({ imgUrl:fallback });
      }
    }
  }

  render() {
    const { children } = this.props;
    const childrenWithProps = React.Children.map(children,
      (child:React.ReactElement<HTMLImageElement|HTMLDivElement>) => {
        const options:object = child.type === 'img' ?
          { src: this.state.imgUrl }
          :
          { style: { backgroundImage: `url(${this.state.imgUrl})` } };
        return React.cloneElement(child, options);
      });
    return (
      <React.Fragment>
        {childrenWithProps}
      </React.Fragment>
    );
  }
}
